import { render, staticRenderFns } from "./curriculumTime.vue?vue&type=template&id=408fcd9c&scoped=true&"
import script from "./curriculumTime.vue?vue&type=script&lang=js&"
export * from "./curriculumTime.vue?vue&type=script&lang=js&"
import style0 from "./curriculumTime.vue?vue&type=style&index=0&id=408fcd9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408fcd9c",
  null
  
)

export default component.exports